import React from 'react';
import { IonCol, IonRow, IonButton } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { colorTheme } from '../../utils/constants';
import { Card } from '@tremor/react';

const TenantTransactionsSummaryCard = (props) => {
    let history = useHistory();

    return (
        <Card 
          key={props.header}
          className='p-3 mb-2'
        >
            <p className="text-tremor-default font-semibold text-tremor-content dark:text-dark-tremor-content">
              {props.header}
            </p>
            <div className="mt-2 flex items-baseline space-x-2.0">
              <p className="text-2xl font-semibold text-tremor-content-strong dark:text-dark-tremor-content-strong">
                {props.body}
              </p>
            </div>
            <p className="mt-1 text-tremor-default text-tremor-content dark:text-dark-tremor-content">
              {props.footer}
            </p>

          </Card>

    )
    // return (
    //         <IonRow size="12" sizeLg="4" sizeMd="6">
    //             <div className="hr-text hr-text-center my-2">
    //                 <span id={props.header + "-header"} className="h5 ml-5"><span style={{fontWeight: "bold"}}>{props.header}</span> {props.body} {props.footer}</span>
    //             </div>
    //         </IonRow>
    // );
}

export default TenantTransactionsSummaryCard;
